import React, { Component, useState } from 'react'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import ALMReportPageUI from './ALMReportPageUI'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'

class ALMReportPageSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            almReport: null,
            almReportSubmitted: false,
            almReportErrorList: [],

            selectedTab: 'goodStanding',

            pendingUpdates: [],
            savingPendingUpdates: false,

            updateDelinquentSubmitted: false,
            updateDelinquentSuccessMsg: null,
            updateDelinquentErrorList: [],

            addMetricMode: false,
            metricType: null,
            metricTableKey: null,
            addMetricSubmitted: false,
            addMetricSuccessMsg: null,
            addMetricErrorList: [],
            metricKey: '',
            metricKeyError: null,

            editMetricMode: false,
            selectedMetric: null,
            metricSaveSubmitted: false,
            metricSaveSuccessMsg: null,
            saveMetricErrorList: []
        }
    }

    render() {
        console.log("selectedTab in SF:", this.state.selectedTab);
        return (
            <ALMReportPageUI
                context={this.props.context}
                almReport={this.state.almReport}
                onRefreshClick={this.onRefreshClick}

                selectedTab={this.state.selectedTab}
                setSelectedTab={(selectedTab) => this.setState({ selectedTab })}

                almReportSubmitted={this.state.almReportSubmitted}
                almReportErrorList={this.state.almReportErrorList}


                onUpdateDelinquentSubmit={this.onUpdateDelinquentSubmit}
                updateDelinquentSubmitted={this.state.updateDelinquentSubmitted}
                updateDelinquentSuccessMsg={this.state.updateDelinquentSuccessMsg}
                updateDelinquentErrorList={this.state.updateDelinquentErrorList}

                onAddMetricClick={this.onAddMetricClick}
                onPendingUpdatesChange={this.onPendingUpdatesChange}
                onSavePendingUpdates={this.onSavePendingUpdates}
                onEditMetricClick={this.onEditMetricClick}

                metricSaveSuccessMsg={this.state.metricSaveSuccessMsg}
                saveMetricErrorList={this.state.saveMetricErrorList}
                setSaveMetricErrorList={(errorList) =>
                    this.setState({ saveMetricErrorList: errorList })
                }

                addMetricMode={this.state.addMetricMode}
                metricType={this.state.metricType}
                onAddMetricSubmit={this.onAddMetricSubmit}
                onAddMetricCancelClick={this.onAddMetricCancelClick}
                addMetricSubmitted={this.state.addMetricSubmitted}
                addMetricSuccessMsg={this.state.addMetricSuccessMsg}
                addMetricErrorList={this.state.addMetricErrorList}
                setAddMetricErrorList={(errorList) => { this.setState({ addMetricErrorList: errorList }) }}
                metricKey={this.state.metricKey}
                onMetricKeyChange={(event) => { this.setState({ metricKey: event.target.value }) }}
                metricKeyError={this.state.metricKeyError}
                setMetricKeyError={(error) => { this.setState({ metricKeyError: error }) }}


                onDownloadClick={this.onDownloadClick}
            />
        )
    }

    componentDidMount() {
        this.getALMReport(this.props.context)
    }

    getALMReport(context) {
        const currentDateISO = new Date().toISOString().split('T')[0]

        this.setState({
            almReportSubmitted: true,
            almReportErrorList: []
        })

        let cacheManager = new CacheManager({
            resource: `/api/su/almreport/report/getReport?currentDateISO=${currentDateISO}`,
            cacheKey: CacheKeys.ALMReport(currentDateISO),
            callback: this.getALMReportCallback,
            ttlInSecs: 600
        })

        cacheManager.getObject2(context)
    }

    getALMReportCallback = (response) => {
        let errorList = []

        if (response && response.errorList) {
            response.errorList.forEach(error => {
                const msg = error ? (typeof error === 'object' ? error.message || error : error) : error
                if (msg) errorList.push(msg)
            })
        }

        this.setState({
            almReport: {
                allAccounts: response.allAccounts,
                goodStandingAccounts: response.goodStandingAccounts
            },
            almReportSubmitted: false,
            almReportSuccessMsg: response.success,
            almReportErrorList: errorList
        })
    }

    onRefreshClick = () => {
        const currentDateParam = new Date().toISOString().split('T')[0]

        if (this.state.pendingUpdates.length > 0) {
            this.savePendingUpdates(() => {
                CacheManager.removeObject(CacheKeys.ALMReport(currentDateParam))
                this.setState({ almReport: null }, () => {
                    this.getALMReport(this.props.context)
                })
            })
            return
        }

        CacheManager.removeObject(CacheKeys.ALMReport(currentDateParam))
        this.setState({ almReport: null }, () => {
            this.getALMReport(this.props.context)
        })
    }

    onDownloadClick = (selectedTab) => {
        const goodStanding = selectedTab === "goodStanding"
        const currentDateISO = new Date().toISOString().split('T')[0];

        if (!this.state.almReport) {
            return;
        }

        this.setState({
            downloadSubmitted: true,
            downloadSuccessMsg: null,
            downloadErrorList: []
        });

        RestApiUtils.post(
            this.props.context,
            `/api/su/almreport/report/excel/fileDownloadSignedUrl?currentDateISO=${currentDateISO}&isGoodStanding=${goodStanding}`,
            this.downloadCallback,
            this.state.almReport
        );
    }

    downloadCallback = (response) => {

        const errorList = response.errorList.map(error => error.message);

        this.setState({
            downloadSubmitted: false,
            downloadSuccessMsg: response.success,
            downloadErrorList: errorList
        });

        if (response.errorList.length > 0) {
            return;
        }

        const link = document.createElement("a");
        link.href = response.signedUrl.signedUrl;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setTimeout(() => {
            this.setState({
                downloadSuccessMsg: null
            });
        }, 1000);
    }

    onUpdateDelinquentSubmit = () => {

        if (this.state.updateDelinquentSubmitted) {
            return
        }

        this.setState({
            updateDelinquentSubmitted: true,
            updateDelinquentSuccessMsg: null,
            updateDelinquentErrorList: []
        })

        RestApiUtils.post(
            this.props.context,
            "/api/su/almreport/report/updateALMTracker",
            this.updateDelinquentCallback
        )
    }
    updateDelinquentCallback = (response) => {

        const errorList = response.errorList || []

        if (errorList.length === 0) {
            const currentDateParam = new Date().toISOString().split('T')[0]

            this.setState({
                updateDelinquentSubmitted: false,
                updateDelinquentSuccessMsg: response.success,
                updateDelinquentErrorList: []
            }, () => {

                CacheManager.removeObject(CacheKeys.ALMReport(currentDateParam))

                this.setState({
                    almReport: null
                }, () => {
                    this.getALMReport(this.props.context)
                })
                setTimeout(() => {
                    this.setState({
                        updateDelinquentSuccessMsg: null
                    });
                }, 3000);

            })

        } else {

            this.setState({
                updateDelinquentSubmitted: false,
                updateDelinquentSuccessMsg: null,
                updateDelinquentErrorList: errorList
            })

        }
    }

    onAddMetricClick = ({ tableKey, metricType }) => {

        this.setState({
            addMetricMode: true,
            metricType: metricType,
            metricTableKey: tableKey,
            addMetricSuccessMsg: null,
            addMetricErrorList: [],
            metricKey: '',
            metricKeyError: null
        })

    }

    onAddMetricSubmit = (event) => {
        event.preventDefault()

        const metricKey = this.state.metricKey.trim()
        const tableKey = this.state.metricTableKey
        const mapType = this.state.metricType === 'outflow' ? 'outflowMetrics' : 'inflowMetrics'

        this.setState({
            almReport: this.getUpdatedALMReport(tableKey, mapType, metricKey,),
            addMetricMode: false,
            addMetricSubmitted: false,
            addMetricSuccessMsg: null,
            addMetricErrorList: [],
            metricKey: '',
            metricTableKey: null,
        })
    }

    onAddMetricCancelClick = () => {
        this.setState({
            addMetricMode: false,
            metricType: null,
            metricTableKey: null,
            addMetricSubmitted: false,
            addMetricSuccessMsg: null,
            addMetricErrorList: [],
            metricKey: '',
            metricKeyError: null
        })
    }

    onPendingUpdatesChange = (request) => {

        this.setState({
            pendingUpdates: request
        })

    }
    onSavePendingUpdates = (request) => {

        this.setState({
            pendingUpdates: request
        }, () => {

            this.savePendingUpdates()

        })

    }

    savePendingUpdates = (callback) => {

        if (this.state.savingPendingUpdates) {
            return
        }

        const request = this.state.pendingUpdates
        if (!request || request.length === 0) {
            if (callback) callback();
            return
        }

        const currentDateISO = new Date().toISOString().split('T')[0]

        this.setState({
            savingPendingUpdates: true,
            metricSaveSuccessMsg: null,
            saveMetricErrorList: []
        })
        RestApiUtils.post(
            this.props.context,
            `/api/su/almreport/report/addMetricValues?currentDateISO=${currentDateISO}`,
            (response) => this.savePendingUpdatesCallback(response, callback),
            request
        )
    }

    savePendingUpdatesCallback = (response, callback) => {

        const errorList = (response && response.errorList)
            ? response.errorList.map(e => (e ? (typeof e === 'object' ? e.message || e : e) : '')).filter(Boolean)
            : []
        console.log("Before setState", this.state.saveMetricErrorList);
        if (errorList.length === 0) {
            const currentDateParam = new Date().toISOString().split('T')[0]

            this.setState({
                savingPendingUpdates: false,
                metricSaveSuccessMsg: response.success,
                saveMetricErrorList: [],
                pendingUpdates: []
            }, () => {

                CacheManager.removeObject(CacheKeys.ALMReport(currentDateParam))
                this.getALMReport(this.props.context)
                if (callback) callback()
            })

        } else {

            this.setState({
                savingPendingUpdates: false,
                metricSaveSuccessMsg: null,
                saveMetricErrorList: errorList
            }, () => {
                console.log("State:", this.state.saveMetricErrorList);
            });

        }

    }

    getUpdatedALMReport = (tableKey, mapType, metricKey) => {

        const almReport = this.state.almReport

        if (!almReport || !tableKey || !metricKey) {
            return almReport
        }

        const updatedTable = { ...almReport[tableKey] }

        Object.keys(updatedTable).forEach(month => {

            updatedTable[month] = {
                ...updatedTable[month],
                [mapType]: {
                    ...(updatedTable[month][mapType] || {}),
                    [metricKey]: ''
                }
            }

        })

        return {
            ...almReport,
            [tableKey]: updatedTable
        }

    }

    onEditMetricClick = (selectedMetric) => {

        this.setState({
            editMetricMode: true,
            selectedMetric: selectedMetric
        })

    }

}

export default ALMReportPageSF
